import React, { useEffect } from "react";
import styled from "@mui/material/styles/styled";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import Button from "@mui/material/Button";
import { MobileView } from "../util/aKaunGeneralUtil";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";

//region [[ Styles ]]
const TabsWrapper = styled("div")(({ theme }) => ({
  overflow: "auto",
  whiteSpace: "nowrap",
  [theme.breakpoints.up("sm")]: {
    "&::-webkit-scrollbar": {
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
    },
  },
}));

const Tab = styled(Button)(
  ({ theme, selected }: { theme?: any; selected: boolean }) => ({
    margin: "2px",
    marginBottom: "10px",
    padding: "2px 18px",
    borderRadius: "33px",

    [theme.breakpoints.up(MobileView)]: {
      backgroundColor: selected ? KahunColorMap.Secondary : "white",
      color: selected ? "white" : KahunColorMap.Secondary,
      "&:hover, &:focus": {
        backgroundColor: selected ? KahunColorMap.Secondary : "white",
        color: selected ? "white" : KahunColorMap.Secondary,
      },
    },

    fontSize: "16px",
    textTransform: "unset",

    [theme.breakpoints.down(MobileView)]: {
      fontSize: "14px",
      backgroundColor: selected ? "white" : KahunColorMap.Secondary,
      color: selected ? KahunColorMap.Secondary : "white",
      "&:hover, &:focus": {
        backgroundColor: selected ? "white" : KahunColorMap.Secondary,
        color: selected ? KahunColorMap.Secondary : "white",
      },
    },
  }),
);
//endregion [[ Styles ]]

//region [[ Props ]]
interface TabsProps {
  items: Array<{ name: string }>;
  selectedIndex: number;
  clickHandler: (number) => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const Tabs = (props: TabsProps) => {
  useEffect(() => {}, [props.selectedIndex]);

  const onSelectTab = (index) => {
    evt({
      category: CATEGORY.MINI_DISEASE,
      action: ACTION.SELECT_MINI_DISEASE_TAB,
      label: props.items[index].name,
    });
    props.clickHandler(index);
  };

  return (
    <TabsWrapper>
      {props.items.map((item, index) => (
        <Tab
          key={index + " " + props.selectedIndex}
          selected={index === props.selectedIndex}
          onClick={() => {
            onSelectTab(index);
          }}
        >
          {item.name}
        </Tab>
      ))}
    </TabsWrapper>
  );
};

export default Tabs;
